import { Endpoint } from "../network/endpoint"
import { HttpManager } from "../network/interface/HttpManager"
import { TransactionsError } from "../../ui/error/TransactionsError"
import { Filter } from "../../domain/types/transactions/Filter"
import { GiftCard } from "../../domain/entities/GiftCard"

export class GiftCardService {
	private _http: HttpManager

	constructor({ HttpManager }: { HttpManager: HttpManager }) {
		this._http = HttpManager
	}

	public async getGiftCards(
		offset?: number,
		limit?: number,
		filter?: Filter
	): Promise<{ giftCards: GiftCard[]; total: number }> {
		try {
			const queryFilter = this.buildFilterQuery(filter)
			const response = await this._http.requestNewApi({
				url: `${Endpoint.GIFT_CARDS}?page=${offset}&limit=${limit}&${queryFilter}`,
				method: "GET"
			})
			return {
				giftCards: response.data.movements || [],
				total: response.data.total || 0
			}
		} catch (error: any) {
			throw new TransactionsError({
				errorMessage: TransactionsError.TRANSACTIONS_GET_ERROR,
				errorCode: error?.error_msg,
				httpStatus: error?.httpStatus
			})
		}
	}

	private buildFilterQuery(filter?: Filter) {
		let filterQuery: any = {}

		if (filter?.createdAt) {
			filterQuery = {
				...filterQuery,
				dateFrom: filter.createdAt[0].format("YYYY-MM-DD"),
				dateTo: filter.createdAt[1].format("YYYY-MM-DD")
			}
		}

		if (filter?.search) {
			filterQuery = { ...filterQuery, search: filter.search }
		}

		return filterQuery
			? Object.keys(filterQuery)
					.map(key => `${key}=${filterQuery[key]}`)
					.join("&")
			: ""
	}
}
